// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"245":"4d772646","422":"6edbe0c9","472":"d3c79b9a","475":"f228bca9","523":"c087ba1a","531":"be890b35","545":"e8bb15ac","595":"9e61b216","671":"8f855cc7","742":"1abded59","787":"d2fddf84","821":"2656978b","827":"aa49884f","834":"6e467993","862":"414d917a","940":"889491d2"}[chunkId] + ".chunk.js";
};